import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit';
import { RootState } from "../index";
import { fetchSession, fetchSessions, updateSession } from "../../actions/mine_craft/sessionsActions";

export interface SessionInterface {
  url: string;

  id: number,
  uid: string,

  user_id: number,
  user: number,

  device_id: number,
  device: number,

  created_at: string,
  updated_at: string
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;

  editId: EntityId | null;
  editError: string | null;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,

  editId: null,
  editError: null
};

const adaptor = createEntityAdapter<SessionInterface>();

const slice = createSlice({
  name: 'sessions',
  initialState: adaptor.getInitialState(initialState),
  reducers: {
    setEditId: (state, action) => {
      state.editId    = action.payload;
      state.editError = initialState.editError;
    },
    setEditError: (state, action) => {
      state.editError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchSessions.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchSessions.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.sessions;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchSessions.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchSession.fulfilled, (state, action) => {
        const session = Object.values(action.payload.session)[0];
        state.entities[session.id] = session;
      })

      // #update
      .addCase(updateSession.fulfilled, (state, action) => {
        const session = Object.values(action.payload.session)[0];
        state.entities[session.id] = session;
      })
      .addCase(updateSession.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.editError = error || action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  setEditId,
  setEditError
} = slice.actions;

export const {
  selectById: selectSessionById,
  selectIds: selectSessionIds,
  selectEntities: selectSessionEntities,
}  = adaptor.getSelectors<RootState>(state => state.mineCraft.sessions);
